// Plain Text with Emoji Notations (and optional template variables)

import type { ReactNode, VFC } from "react";
import { useContext } from "react";

import { splitEmojis } from "../splitEmojis";

import { CustomEmojiContext } from "./customEmoji/CustomEmojiProvider";

import { isCustomEmoji } from "~/client/features/emoji/isCustomEmoji";

interface Props {
  children: ReactNode;
  className?: string;
}

export const ExtendedText: VFC<Props> = ({ children, className }) => {
  const customEmojis = useContext(CustomEmojiContext);

  if (typeof children !== "string") {
    return <span className={className}>{children}</span>;
  }

  return (
    <span className={className}>
      {splitEmojis(children, customEmojis).map(({ token, url }, index) => {
        if (url === "") {
          return token;
        } else if (!isCustomEmoji(url)) {
          return url;
        }

        return <img key={`${token}-${index}`} className="emoji" alt={token} src={url} />;
      })}
    </span>
  );
};
